import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/templates/TemplateSwitch/GeneralSwitch.tsx");
